<template>
  <section class="dp-layout">
    <section class="dp-left">
      <DepartmentPane directory-scope="school" @tree-node-click="treeNodeClick" :type="1"></DepartmentPane>
    </section>

    <section class="dp-right wr-stat-page">
      <toolbar ref="toolbar" :buttonList="buttonList" @callFunction="callFunction" :searchList="searchList"></toolbar>

      <!-- 清浮动，避免被 Toolbar 的 el-col 挤到右侧竖排 -->
      <div class="wr-stat-body">
        <div class="wr-stat-summary">
          <div class="wr-stat-card wr-stat-card--blue">
            <div class="wr-stat-value">{{ summaryNum('TeacherCount', 'teacherCount') }}</div>
            <div class="wr-stat-label">教师数</div>
          </div>
          <div class="wr-stat-card wr-stat-card--green">
            <div class="wr-stat-value">{{ summaryNum('SubmitCount', 'submitCount') }}</div>
            <div class="wr-stat-label">提交次数</div>
          </div>
          <div class="wr-stat-card wr-stat-card--orange">
            <div class="wr-stat-value">{{ summaryNum('TodaySubmitCount', 'todaySubmitCount') }}</div>
            <div class="wr-stat-label">当日提交总数</div>
          </div>
        </div>

        <div class="tbl-scroll-host">
        <el-table :data="rows" v-loading="listLoading" class="custom-tbl" height="100%" style="width: 100%" empty-text="暂无数据">
          <el-table-column prop="TeacherName" label="教师姓名" width="100" align="center" header-align="center" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-button type="text" class="wr-name-link" @click="openTeacherDetail(scope.row)">
                {{ scope.row.TeacherName || scope.row.teacherName || '-' }}
              </el-button>
            </template>
          </el-table-column>
          <el-table-column label="身份" width="100" align="center" header-align="center">
            <template slot-scope="scope">
              <template v-if="rolesOf(scope.row).length">
                <el-tag
                  v-for="r in rolesOf(scope.row)"
                  :key="'role-' + r"
                  :type="r === 1 ? '' : 'success'"
                  size="mini"
                  style="margin: 2px"
                >{{ r === 1 ? '班主任' : '任课教师' }}</el-tag>
              </template>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column label="关联班级" min-width="180" align="center" header-align="center" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ scope.row.ClassNames || scope.row.classNames || '-' }}
            </template>
          </el-table-column>
          <el-table-column label="校区" min-width="200" align="center" header-align="center" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ scope.row.CampusName || scope.row.campusName || '-' }}
            </template>
          </el-table-column>
          <el-table-column label="提交次数" width="90" align="center" header-align="center">
            <template slot-scope="scope">
              {{ scope.row.SubmitCount != null ? scope.row.SubmitCount : scope.row.submitCount }}
            </template>
          </el-table-column>
          <el-table-column label="当日提交总数" width="110" align="center" header-align="center">
            <template slot-scope="scope">
              {{ scope.row.TodaySubmitCount != null ? scope.row.TodaySubmitCount : scope.row.todaySubmitCount }}
            </template>
          </el-table-column>
          <el-table-column label="操作" width="100" align="center" header-align="center">
            <template slot-scope="scope">
              <el-button type="text" size="mini" @click="openTeacherDetail(scope.row)">查看明细</el-button>
            </template>
          </el-table-column>
        </el-table>
        </div>
      </div>

      <!--分页（与 WorkRecordList 保持一致）-->
      <el-col :span="24" class="toolbar">
        <el-pagination layout="total, prev, pager, next, jumper" @current-change="handleCurrentChange"
          :page-size="PageSize" :total="total" style="float: right">
        </el-pagination>
      </el-col>

      <!-- 教师时段明细弹窗。创建于 2026-07-23 -->
      <el-dialog 
        :title="detailDialogTitle"
        :visible.sync="detailDialogVisible"
        width="1360px"
        append-to-body
        :close-on-click-modal="false"
        @closed="onDetailDialogClosed"
      >
        <el-table
          v-loading="detailLoading"
          :data="detailRows"
          border
          stripe
          style="width: 100%"
          :max-height="detailRows.length > 10 ? 480 : undefined"
          empty-text="该时段暂无提交记录"
        >
          <el-table-column label="记录日期" width="110" align="center" header-align="center">
            <template slot-scope="scope">{{ formatSimpleDate(scope.row.RecordDate || scope.row.recordDate) }}</template>
          </el-table-column>
          <el-table-column label="身份" width="100" align="center" header-align="center">
            <template slot-scope="scope">
              <el-tag :type="(scope.row.TeacherRole || scope.row.teacherRole) === 1 ? '' : 'success'" size="mini">
                {{ (scope.row.TeacherRole || scope.row.teacherRole) === 1 ? '班主任' : '任课教师' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="关联班级" min-width="120" align="center" header-align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.ClassName || scope.row.className || '-' }}</template>
          </el-table-column>
          <el-table-column label="工作内容" min-width="120" align="center" header-align="center">
            <template slot-scope="scope">
              <template v-if="(scope.row.ConfigNames || scope.row.configNames || []).length">
                <el-tag
                  v-for="tag in (scope.row.ConfigNames || scope.row.configNames)"
                  :key="tag"
                  size="mini"
                  type="primary"
                  style="margin: 2px"
                >{{ tag }}</el-tag>
              </template>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column label="详细描述" min-width="140" align="center" header-align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.CustomContent || scope.row.customContent || '-' }}</template>
          </el-table-column>
          <el-table-column label="图片" width="132" align="center" header-align="center">
            <template slot-scope="scope">
              <oss-media-thumbs
                v-if="showImage(scope.row.MediaFiles || scope.row.mediaFiles).length"
                :media="scope.row.MediaFiles || scope.row.mediaFiles"
                :max="3"
                thumb-width="36px"
                wrapper-class="wr-media-thumbs"
                img-class="wr-media-thumb"
              />
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column label="附件" width="130" align="center" header-align="center">
            <template slot-scope="scope">
              <template v-if="(scope.row.Attachments || scope.row.attachments || []).length">
                <template v-for="disp in [buildAttachmentDisplay(scope.row.Attachments || scope.row.attachments)]">
                  <div v-if="disp.mode === 'full'" :key="'full-' + scope.$index" class="wr-attach-tags wr-attach-tags--full">
                    <el-tag
                      v-for="tag in disp.visibleTags"
                      :key="tag.ext"
                      size="mini"
                      type="info"
                      class="wr-attach-tag"
                    >
                      {{ tag.label }}
                    </el-tag>
                  </div>
                  <div v-else :key="'compact-' + scope.$index" class="wr-attach-tags wr-attach-tags--compact">
                    <div class="wr-attach-row">
                      <el-tag
                        v-for="tag in disp.visibleTags"
                        :key="tag.ext"
                        size="mini"
                        type="info"
                        class="wr-attach-tag"
                      >
                        {{ tag.label }}
                      </el-tag>
                    </div>
                    <span class="wr-attach-more">等{{ disp.moreCount }}个附件</span>
                  </div>
                </template>
              </template>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column label="提交时间" min-width="160" align="center" header-align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.SubmitTime || scope.row.submitTime || '-' }}</template>
          </el-table-column>
          <el-table-column label="操作" width="80" align="center" header-align="center">
            <template slot-scope="scope">
              <el-button type="text" size="mini" @click="openRecordDetail(scope.row)">详情</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-col :span="24" class="toolbar">
          <el-pagination
            layout="total, prev, pager, next, jumper"
            :page-size="detailPageSize"
            :current-page.sync="detailPage"
            :total="detailTotal"
            style="float: right"
            @current-change="loadTeacherDetailPage"
          />
        </el-col>
      </el-dialog>

      <work-record-detail-dialog :visible.sync="recordDetailVisible" :record="recordDetailRow" />
    </section>
  </section>
</template>

<script>
import { getWorkRecordStatistics, getWorkRecordList, exportWorkRecordStatistics, getCampusList } from '../../api/modules/misc';
import { getButtonList } from '../../promissionRouter';
import Toolbar from '../../components/Toolbar';
import DepartmentPane from '../../components/DepartmentPane';
import WorkRecordDetailDialog from '../../components/WorkRecord/WorkRecordDetailDialog.vue';
import { fileExtFromMedia } from '../../utils/mediaUrl';
import { toDeptId, treeNodeDeptId } from '../../utils/deptCascaderProps';

/** 默认统计区间：本月 1 日 ~ 今天。创建于 2026-07-23 */
function buildDefaultDateRange() {
  const end = new Date();
  const start = new Date(end.getFullYear(), end.getMonth(), 1);
  const fmt = (d) => {
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${y}-${m}-${day}`;
  };
  return { startDate: fmt(start), endDate: fmt(end) };
}

export default {
  name: 'WorkRecordStatistics',
  components: { Toolbar, DepartmentPane, WorkRecordDetailDialog },
  data() {
    const defaults = buildDefaultDateRange();
    return {
      filters: {
        teacherName: '',
        campusId: null,
        role: null,
        startDate: defaults.startDate,
        endDate: defaults.endDate
      },
      searchList: [
        {
          label: '教师姓名',
          key: 'teacherName',
          width: '150px',
          initValue: ''
        },
        {
          label: '选择校区',
          key: 'campusId',
          type: 'select',
          width: '160px',
          clearable: true,
          initValue: null,
          options: []
        },
        {
          label: '身份',
          key: 'role',
          type: 'select',
          width: '120px',
          clearable: true,
          initValue: null,
          options: [
            { label: '班主任', value: 1 },
            { label: '任课教师', value: 2 }
          ]
        },
        {
          label: '开始时间',
          key: 'startDate',
          type: 'date',
          width: '170px',
          initValue: defaults.startDate
        },
        {
          label: '结束时间',
          key: 'endDate',
          type: 'date',
          width: '170px',
          initValue: defaults.endDate
        }
      ],
      departmentId: 0,
      rows: [],
      summary: null,
      total: 0,
      page: 1,
      PageSize: 10,
      listLoading: false,
      buttonList: [],
      detailDialogVisible: false,
      detailDialogTitle: '教师明细',
      detailLoading: false,
      detailRows: [],
      detailTotal: 0,
      detailPage: 1,
      detailPageSize: 10,
      detailQuery: null,
      recordDetailVisible: false,
      recordDetailRow: null
    };
  },
  methods: {
    roleOf(row) {
      return row.TeacherRole != null ? row.TeacherRole : row.teacherRole;
    },
    /** 区间内全部身份（兼容仅返回单个 TeacherRole）。创建于 2026-07-23 */
    rolesOf(row) {
      const list = row.TeacherRoles || row.teacherRoles;
      if (Array.isArray(list) && list.length) {
        return list.map(Number).filter(r => r === 1 || r === 2);
      }
      const one = this.roleOf(row);
      return one === 1 || one === 2 ? [one] : [];
    },
    summaryNum(pascalKey, camelKey) {
      if (!this.summary) return 0;
      const v = this.summary[pascalKey] != null ? this.summary[pascalKey] : this.summary[camelKey];
      return v != null ? v : 0;
    },
    /** 统一成 yyyy-MM-dd，兼容 Date / 字符串 */
    toDateStr(val) {
      if (!val) return '';
      if (typeof val === 'string') {
        return val.length >= 10 ? val.substring(0, 10) : val;
      }
      if (val instanceof Date && !isNaN(val.getTime())) {
        const y = val.getFullYear();
        const m = String(val.getMonth() + 1).padStart(2, '0');
        const day = String(val.getDate()).padStart(2, '0');
        return `${y}-${m}-${day}`;
      }
      return '';
    },
    formatSimpleDate(time) {
      if (!time) return '-';
      if (typeof time === 'string' && time.length >= 10) return time.slice(0, 10);
      return this.toDateStr(time) || '-';
    },
    /** 列表附件类型键（优先 FileType，否则从 URL 推断） */
    attachmentTypeKey(file) {
      const ext = fileExtFromMedia(file && file.FileUrl, file && file.FileType);
      if (!ext) return '文件';
      return ext.replace(/^\./, '').toLowerCase();
    },
    getAttachmentCounts(attachments) {
      const counts = {};
      (attachments || []).forEach(file => {
        const ext = this.attachmentTypeKey(file);
        counts[ext] = (counts[ext] || 0) + 1;
      });
      return counts;
    },
    /**
     * 明细附件列展示：≤3 种类型最多三行横排；超出则两行（前 2 个标签 + 等 N 个附件）
     */
    buildAttachmentDisplay(attachments) {
      const list = attachments || [];
      const counts = this.getAttachmentCounts(list);
      const tags = Object.keys(counts).map((ext) => ({
        ext,
        count: counts[ext],
        label: `${counts[ext]}个${ext}`,
      }));
      if (tags.length <= 3) {
        return { mode: 'full', visibleTags: tags, moreCount: 0 };
      }
      const visibleTags = tags.slice(0, 2);
      const shownFileCount = visibleTags.reduce((sum, t) => sum + t.count, 0);
      return {
        mode: 'compact',
        visibleTags,
        moreCount: Math.max(0, list.length - shownFileCount),
      };
    },
    ensureDateDefaults() {
      const defaults = buildDefaultDateRange();
      if (!this.toDateStr(this.filters.startDate)) {
        this.filters.startDate = defaults.startDate;
      }
      if (!this.toDateStr(this.filters.endDate)) {
        this.filters.endDate = defaults.endDate;
      }
    },
    syncToolbarDates() {
      this.ensureDateDefaults();
      if (!this.$refs.toolbar) return;
      const obj = Object.assign({}, this.$refs.toolbar.searchObj || {});
      obj.teacherName = this.filters.teacherName || '';
      obj.campusId = this.filters.campusId;
      obj.role = this.filters.role;
      obj.startDate = this.toDateStr(this.filters.startDate);
      obj.endDate = this.toDateStr(this.filters.endDate);
      this.$refs.toolbar.searchObj = obj;
    },
    treeNodeClick(data) {
      const id = treeNodeDeptId(data);
      if (!id) return;
      this.departmentId = id;
      this.page = 1;
      this.filters.campusId = null;
      this.ensureDateDefaults();
      this.$nextTick(() => {
        this.syncToolbarDates();
      });
      this.loadCampusOptions(this.departmentId);
      this.handleQuery();
    },
    loadCampusOptions(deptId) {
      const schoolId = deptId || this.departmentId;
      const campusSearch = this.searchList.find(e => e.key === 'campusId');
      if (!toDeptId(schoolId)) {
        if (campusSearch) campusSearch.options = [];
        return;
      }
      getCampusList({ page: 1, intPageSize: 999, departmentId: schoolId }).then(res => {
        if (res.data.success) {
          const list = res.data.response.data || [];
          if (campusSearch) {
            campusSearch.options = list.map(e => ({
              label: e.Name,
              value: e.Id
            }));
          }
        }
      });
    },
    handleCurrentChange(val) {
      this.page = val;
      this.handleQuery();
    },
    handleQuery() {
      if (!toDeptId(this.departmentId)) {
        this.$message({ message: '请先从左侧选择具体的机构/学校再查询', type: 'error' });
        return;
      }
      this.ensureDateDefaults();
      const startDate = this.toDateStr(this.filters.startDate);
      const endDate = this.toDateStr(this.filters.endDate);
      if (!startDate || !endDate) {
        this.$message({ message: '请选择统计时间段（开始/结束时间）', type: 'warning' });
        return;
      }
      const para = {
        departmentId: this.departmentId,
        page: this.page,
        pageSize: this.PageSize,
        teacherName: this.filters.teacherName || '',
        campusId: this.filters.campusId || null,
        role: this.filters.role || null,
        startDate,
        endDate
      };
      this.listLoading = true;
      getWorkRecordStatistics(para).then(res => {
        if (res.data.success) {
          const resp = res.data.response || {};
          this.summary = resp.Summary || resp.summary || null;
          const pageObj = resp.Page || resp.page || {};
          this.rows = pageObj.data || pageObj.Data || [];
          this.total = pageObj.dataCount || pageObj.DataCount || 0;
        } else {
          this.$message.error(res.data.msg || '查询失败');
          this.summary = null;
          this.rows = [];
          this.total = 0;
        }
        this.listLoading = false;
      }).catch(() => {
        this.listLoading = false;
      });
    },
    /**
     * 弹窗查看该教师在统计时段内的提交明细（不跳转列表页）。
     * 与列表筛选一致：有选身份则明细只带该身份；未选则班主任+任课全部。最后更新：2026-07-23
     */
    openTeacherDetail(row) {
      if (!toDeptId(this.departmentId)) {
        this.$message({ message: '请先从左侧选择具体的机构/学校', type: 'error' });
        return;
      }
      const name = row.TeacherName || row.teacherName || '';
      if (!name) {
        this.$message.warning('无法识别教师姓名');
        return;
      }
      this.ensureDateDefaults();
      const startDate = this.toDateStr(this.filters.startDate);
      const endDate = this.toDateStr(this.filters.endDate);
      const filterRole = this.filters.role ? Number(this.filters.role) : null;
      this.detailQuery = {
        departmentId: this.departmentId,
        teacherName: name,
        startDate,
        endDate,
        role: filterRole > 0 ? filterRole : null
      };
      this.detailDialogTitle = `${name} · ${startDate} ~ ${endDate}`;
      this.detailPage = 1;
      this.detailDialogVisible = true;
      this.loadTeacherDetailPage(1);
    },
    loadTeacherDetailPage(page) {
      if (!this.detailQuery) return;
      this.detailLoading = true;
      const para = {
        departmentId: this.detailQuery.departmentId,
        teacherName: this.detailQuery.teacherName,
        startDate: this.detailQuery.startDate,
        endDate: this.detailQuery.endDate,
        page: page || this.detailPage,
        pageSize: this.detailPageSize
      };
      if (this.detailQuery.role) para.role = this.detailQuery.role;
      getWorkRecordList(para).then(res => {
        if (res.data.success) {
          const pm = res.data.response || {};
          this.detailRows = pm.data || pm.Data || [];
          this.detailTotal = pm.dataCount || pm.DataCount || 0;
          this.detailPage = pm.page || page || 1;
        } else {
          this.$message.error(res.data.msg || '加载明细失败');
          this.detailRows = [];
          this.detailTotal = 0;
        }
        this.detailLoading = false;
      }).catch(() => {
        this.detailLoading = false;
      });
    },
    onDetailDialogClosed() {
      this.detailRows = [];
      this.detailTotal = 0;
      this.detailQuery = null;
    },
    /** 打开单条记录详情（与工作记录列表共用弹窗）。创建于 2026-07-23 */
    openRecordDetail(row) {
      this.recordDetailRow = row;
      this.recordDetailVisible = true;
    },
    /**
     * 导出当前筛选条件下的教师统计。创建于 2026-07-23
     */
    async exportExcel() {
      if (!toDeptId(this.departmentId)) {
        this.$message({ message: '请先从左侧选择具体的机构/学校再导出', type: 'error' });
        return;
      }
      this.ensureDateDefaults();
      const startDate = this.toDateStr(this.filters.startDate);
      const endDate = this.toDateStr(this.filters.endDate);
      if (!startDate || !endDate) {
        this.$message({ message: '请选择统计时间段（开始/结束时间）', type: 'warning' });
        return;
      }
      try {
        const para = {
          departmentId: this.departmentId,
          teacherName: this.filters.teacherName || '',
          campusId: this.filters.campusId || null,
          role: this.filters.role || null,
          startDate,
          endDate
        };
        const response = await exportWorkRecordStatistics(para);
        if (!response.data) {
          this.$message.error('导出数据为空');
          return;
        }
        let finalFileName = '工作记录统计.xlsx';
        const disposition = response.headers['content-disposition'];
        if (disposition) {
          const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
          const matches = filenameRegex.exec(disposition);
          if (matches != null && matches[1]) {
            let backendFileName = matches[1].replace(/['"]/g, '');
            if (backendFileName.toLowerCase().startsWith("utf-8''")) {
              backendFileName = decodeURIComponent(backendFileName.substring(7));
            } else {
              try {
                backendFileName = decodeURIComponent(backendFileName);
              } catch (e) {
                /* ignore */
              }
            }
            if (backendFileName) finalFileName = backendFileName;
          }
        }
        const blob = new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', finalFileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
        this.$message.success('导出成功');
      } catch (error) {
        console.error('导出失败:', error);
        this.$message.error('导出失败');
      }
    },
    callFunction(item) {
      if (typeof item.search === 'object') {
        this.filters = Object.assign({}, this.filters, item.search);
      }
      this.page = 1;
      this[item.Func].apply(this, [item]);
    }
  },
  mounted() {
    const routers = window.localStorage.router ? JSON.parse(window.localStorage.router) : [];
    this.buttonList = getButtonList(this.$route.path, routers);
    if (!this.buttonList || !this.buttonList.length) {
      this.buttonList = [
        { name: '查询', Func: 'handleQuery' },
        { name: '导出', Func: 'exportExcel' }
      ];
    } else if (!this.buttonList.some(b => b.Func === 'exportExcel')) {
      this.buttonList.push({ name: '导出', Func: 'exportExcel' });
    }
    this.$nextTick(() => {
      this.syncToolbarDates();
    });
  }
};
</script>

<style scoped>
.wr-stat-page {
  overflow: hidden;
}
.wr-stat-body {
  clear: both;
  width: 100%;
  margin-top: 8px;
  /* 桌面铺满由 split-layout.css 的 .wr-stat-body + .tbl-scroll-host 规则负责 */
}
.wr-stat-summary {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
  margin: 0 0 16px;
  width: 100%;
  flex-shrink: 0;
}
.wr-stat-card {
  padding: 14px 12px;
  background: #f8fafc;
  border: 1px solid #ebeef5;
  border-radius: 8px;
  text-align: center;
}
.wr-stat-value {
  font-size: 26px;
  font-weight: 600;
  line-height: 1.2;
  color: #0f172a;
}
.wr-stat-label {
  margin-top: 6px;
  font-size: 12px;
  color: #909399;
}
.wr-stat-card--blue .wr-stat-value {
  color: var(--btn-primary, #2563eb);
}
.wr-stat-card--green .wr-stat-value {
  color: #67c23a;
}
.wr-stat-card--orange .wr-stat-value {
  color: #e6a23c;
}
.wr-name-link {
  padding: 0;
  font-weight: 500;
}
.wr-media-thumbs {
  display: inline-flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;
  gap: 4px;
}
.wr-media-thumb {
  width: 36px;
  height: 36px;
  border-radius: 4px;
  object-fit: cover;
  flex-shrink: 0;
  overflow: hidden;
  border: 1px solid #e2e8f0;
}
.wr-attach-tags {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-content: flex-start;
  gap: 2px 4px;
}
.wr-attach-tags--full {
  max-height: 66px;
  overflow: hidden;
}
.wr-attach-tags--compact {
  flex-direction: column;
  align-items: center;
  gap: 4px;
}
.wr-attach-row {
  display: flex;
  flex-wrap: nowrap;
  justify-content: center;
  gap: 4px;
}
.wr-attach-more {
  font-size: 12px;
  font-weight: 600;
  color: #64748b;
  line-height: 1.3;
  white-space: nowrap;
}
.wr-attach-tag {
  margin: 0;
  flex-shrink: 0;
}
@media (max-width: 900px) {
  .wr-stat-summary {
    grid-template-columns: 1fr;
  }
}
</style>
